export function hasMore
    (state = false , action: any) {
    switch (action.type) {
        case 'HAS_MORE':
            return action.data;
        default:
            return state;
    }
}